import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import NurseProfilePic from "../../assets/images/Nurse-profile-pic.png";
import NurseProfileModal from "./NurseProfileModal";



const AppointmentTimeSchedule = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { selectedDate, selectedTimeZone, selectedType, appointmentType, SlotType, OffSet, OffsetDiff,calendarType, ConsultType = "" } = location.state || {};
  console.log("Location state:", location.state);
  const [loading, setLoading] = useState(true);
  const emailId = useSelector((state) => state.userData);
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedNurseIdx, setSelectedNurseIdx] = useState(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [bookingStatus, setBookingStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [appointments, setAppointments] = useState([]);
  const [showNurseModal, setShowNurseModal] = useState(false);
  const [matchingAppointment, setmatchingAppointment] = useState([]);
  const [isBooking, setIsBooking] = useState(false);
  const [modalResolver, setModalResolver] = useState(null);
  const [showFavoriteModal, setShowFavoriteModal] = useState(false);
  const [showNurseProfile, setShowNurseProfile] = useState(false);
  const [selectedNurseProfile, setSelectedNurseProfile] = useState(null);
  const [selectedNurse, setSelectedNurse] = useState(null);


  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  const getCalendarType = (calendarType) => {
  if (calendarType === 'Primary') {
    return 'Primary';
  }
  if (calendarType === '' || calendarType === 'All') {
    return 'All';
  }
  return calendarType;
};

  // Toggle favorite (primary) nurse
  // Move fetchAvailableSlots to top-level scope so it can be called from handleToggleFavorite
  const fetchAvailableSlots = async () => {
    debugger
    try {
      const token = localStorage.getItem("AccessToken");
      const formatDate = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      };
      const formattedDate = formatDate(new Date(selectedDate));
      const params = {
        OffSet: OffSet,
        SlotType: SlotType,
        Module: "APP",
        Role: "RN",
        TimeZoneName: selectedTimeZone,
        EmailID: emailId.userData.EmailID,
        date: formattedDate,
        CalendarType: getCalendarType(calendarType) || 'All',
        OffsetDiff: OffsetDiff,
        ConsultType: ConsultType,
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
      };
      const response = await axios.post(
        Endpoints.fetchAvailableSlots,
        { _Params: JSON.stringify(params) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data && response.data.NurseDetails && Array.isArray(response.data.NurseDetails) && response.data.NurseDetails.length > 0) {
        setTimeSlots(response.data.NurseDetails);
      } else {
        setTimeSlots([]);
      }
    } catch (error) {
      setTimeSlots([]);
      console.error("Failed to fetch available slots:", error);
    }
  };

  useEffect(() => {
    // debugger
    const fetchAvailableSlots = async () => {
      try {
        const token = localStorage.getItem("AccessToken");
        // Function to format the date as mm-dd-yyyy
        const formatDate = (date) => {
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based, so add 1
          const day = String(date.getDate()).padStart(2, '0');
          const year = date.getFullYear();
          return `${month}-${day}-${year}`;
        };

        const formattedDate = formatDate(new Date(selectedDate));
        console.log(formattedDate);

        const params = {
          OffSet: OffSet,
          SlotType: SlotType,
          Module: "APP",
          Role: "RN",
          TimeZoneName: selectedTimeZone,
          EmailID: emailId.userData.EmailID,
          date: formattedDate,
          CalendarType: getCalendarType(calendarType) || 'All',
          OffsetDiff: OffsetDiff,
          ConsultType: ConsultType,
          DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        };

        const response = await axios.post(
          Endpoints.fetchAvailableSlots,
          { _Params: JSON.stringify(params) },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Connection": "close",
              "Accept": "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Check if the response contains time slots
        if (response.data && response.data.NurseDetails && Array.isArray(response.data.NurseDetails) && response.data.NurseDetails.length > 0) {
          console.log('time slots', response.data)
          setTimeSlots(response.data.NurseDetails);
        } else {
          console.log("No time slots available for the selected date.");
          setTimeSlots([]);
        }
      } catch (error) {
        console.error("Failed to fetch available slots:", error);
      }
      finally {
        setLoading(false);
      }
    };

    if (selectedDate && selectedTimeZone) {
      fetchAvailableSlots();
      fetchAppointments(emailId);
    }
  }, [selectedDate, selectedTimeZone, emailId, ConsultType]);


  const fetchAppointments = async (emailId) => {
    try {
      const token = localStorage.getItem("AccessToken");

      const params = {
        Email: emailId.userData.EmailID,
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
      };

      const response = await axios.post(
        Endpoints.fetchAppointments,
        { _Params: JSON.stringify(params) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      if (response.data && Array.isArray(response.data)) {
        setAppointments(response.data);
        console.log(response.data)
      } else {
        console.error("Unexpected response format:", response.data);
      }
    } catch (error) {
      console.error("Failed to fetch appointments:", error);
    }
  };

  const confirmCancellation = async () => {
    try {
      const token = localStorage.getItem("AccessToken");

      const params = {
        Time: matchingAppointment.Time,
        OffSet: matchingAppointment.OffSet, // Adjust this value as needed
        TimeZoneName: matchingAppointment.TimeZoneName,
        SlotType: matchingAppointment.SlotType,
        Text: "Booked", // Set the cancellation text
        SelectedDate: matchingAppointment.SelectedDate,
        UserName: "MAPP", // Set the user name accordingly
        CalendarType: "All",
        Email: emailId.userData.EmailID,
        OffsetDiff: matchingAppointment.OffsetDiff, // Set the offset difference as needed
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
      };

      const response = await axios.post(
        Endpoints.confirmCancellation,
        { _Params: JSON.stringify(params) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      if (response.data?.Result === 2) {
        // Optionally, you can show a success message or update the state
        console.log("Appointment canceled successfully");
      }  else if(response.data?.Result === 1){
        fetchAvailableSlots();
        setShowModal(true);
        setModalMessage(response.data?.Data);
      } else {
        console.error("Failed to cancel appointment:", response.data);
      }
    } catch (error) {
      console.error("Error canceling appointment:", error);
    }
    finally {
      // Close modal and clear the selected appointment
      setShowModal(false);
      //setAppointmentToCancel(null);
    }
  };



  const handleTimeSlotClick = (nurseIdx, slot) => {
    debugger
    setSelectedNurseIdx(nurseIdx);
    setSelectedTimeSlot(slot);
    setSelectedNurse(timeSlots[nurseIdx]);
  };

  const handleBook = () => {

    if (isBooking) return; // Prevent multiple clicks
    setIsBooking(true); // Disable button
    let appointmentToCancel = null;
    // Extract the part of SlotType before the first hyphen
    const formattedSlotType = SlotType.split('-')[0].trim();
    // Check if the selected type and slot type match
    if (selectedType === formattedSlotType) {
      // Check if any appointment matches the selected type
      if (appointments && appointments.length > 0) {
        // Loop through the appointments to find the one that matches
        for (let appointment of appointments) {
          // Extract the part of appointment's SlotType before the hyphen
          const appointmentSlotType = appointment.SlotType.split('-')[0].trim();

          // If the SlotType matches, set it to appointmentToCancel
          if (appointmentSlotType === formattedSlotType) {
            appointmentToCancel = appointment;  // Assign matched appointment
            break;  // Exit the loop once a match is found
          }
        }
      }
      // If an appointment is found, set it in the state
      if (appointmentToCancel) {
        console.log("Matching appointment found:", appointmentToCancel);
        setmatchingAppointment(appointmentToCancel); // Set the matching appointment to state
        setModalMessage(` Currently you have a ${appointmentToCancel.SlotType} appointment scheduled. You can only schedule one appointment at a time. Would you like to cancel your existing appointment and book the current selection?`);
        setShowNurseModal(true); // Show the confirmation modal
        setIsBooking(false); // Re-enable button since modal is shown
      } else {
        console.log('No matching appointment found');
        handleBookAppointment(); // If no matching appointment, proceed with booking
      }

    } else {
      handleBookAppointment();
    }
  }


  const handleBookAppointment = async () => {
    // debugger
    if (selectedNurseIdx === null || !selectedTimeSlot) {
      setModalMessage("Please select a time slot before booking.");
      setShowModal(true);
      setIsBooking(false);
      return;
    }
    // Use selectedNurseIdx and selectedTimeSlot directly
    const nurse = timeSlots[selectedNurseIdx];
    if (!nurse || !nurse.AvailableSlots.includes(selectedTimeSlot)) {
      setModalMessage("Please select a valid time slot before booking.");
      setShowModal(true);
      setIsBooking(false);
      return;
    }
    const slotToBook = selectedTimeSlot;

    try {
      const token = localStorage.getItem("AccessToken");

      // Function to format the date as mm-dd-yyyy
      const formatDate = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based, so add 1
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      };

      const formattedDate = formatDate(new Date(selectedDate));
      console.log(formattedDate);
      debugger
      const bookingParams = {
        OffSet: OffSet,
        SlotType: SlotType,
        TimeZoneName: selectedTimeZone,
        Time: slotToBook,
        NurseName: selectedNurse.NurseFullName,
        Text: "Available",
        SelectedDate: formattedDate,
        UserName: "MAPP",
        CalendarType: "All",
        Email: emailId.userData.EmailID,
        OffsetDiff: OffsetDiff,
        ConsultType: ConsultType,
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
      };
      console.log("Booking Params:", bookingParams);
      const bookingResponse = await axios.post(
        Endpoints.handleBookAppointment,
        { _Params: JSON.stringify(bookingParams) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Booking Response:", bookingResponse);
      if (bookingResponse.data?.Result === 2) {
        setBookingStatus("Appointment booked successfully.");
        setModalMessage("Appointment booked successfully.");
        setShowModal(true);
      } else if(bookingResponse.data?.Result === 1){
        fetchAvailableSlots();
        setShowModal(true);
        setModalMessage(bookingResponse.data?.Data);
      } else {
        setBookingStatus("Failed to book the appointment. Please try again.");
      }
    } catch (error) {
      console.error("Booking failed:", error);
      setBookingStatus("Booking failed due to an error.");
    } finally {
      setIsBooking(false); // Re-enable button after response
    }
  };
  const handleModalClose = () => {
    setShowModal(false);
    // Navigate to home after closing the modal on successful booking
    if (modalMessage === "Appointment booked successfully.") {
      navigate("/home");
    }
  };
  const confirmCancel = async () => {
    setShowNurseModal(false)
    setIsBooking(true);
    await confirmCancellation();
    // Call handleBookAppointment after confirming cancellation
    handleBookAppointment();
  };
  const handleBackClick = () => {
    navigate(-1); // Redirects to the home page
  };
  // Toggle favorite (primary) nurse
  const handleToggleFavorite = async (nurse) => {
    debugger
     // If nurse is already primary, do nothing
  if (nurse.IsPrimaryStatus === "P") {
    setModalMessage("This nurse is already your primary Nurse Care Advocate.");
    setShowModal(true);
    return;
  }
    try {
      // debugger
      const token = localStorage.getItem("AccessToken");
      let notifyValue = "Y";
      if (nurse.IsPrimaryStatus === "N") {
        notifyValue = await askNotifyProvider();
        if (notifyValue !== "Y") {
          // User selected No, abort the API call
          setShowFavoriteModal(false);
          return;
        }
        setShowFavoriteModal(false);
      }
      // Prepare params for API call
      const params = {
        NurseName: nurse.NurseFullName,
        MemberId: emailId.userData.MemberID,
        Role: "RN",
        Contract: emailId.userData.ContractIdentified,
        EmailID: emailId.userData.EmailID,
        IsFavouriteFlag: nurse.IsPrimaryStatus === "P" ? "N" : "Y", // Toggle
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal"
      };
      console.log("Params for toggling favorite nurse:", params);
      const response = await axios.post(
        Endpoints.LoadNCAProfileDetails,
        { _Params: JSON.stringify(params) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Response from toggling favorite nurse:", response);
      if (response.status === 200 && Array.isArray(response.data) &&
      response.data[0]?.isPrimarySuccess === "Y"
    ) {
        fetchAvailableSlots();
        setModalMessage("Primary nurse updated successfully.");
        setShowModal(true);
      } else {
        fetchAvailableSlots();
        setModalMessage("Failed to update primary nurse.");
        setShowModal(true);
      }
    } catch (error) {
      setModalMessage("Error updating primary nurse.");
      setShowModal(true);
      console.error("Error updating primary nurse:", error);
    }
  };

  const askNotifyProvider = () => {
    return new Promise((resolve) => {
      setModalResolver(() => resolve); // Store resolve to call on Yes/No
      setShowFavoriteModal(true);
    });
  };

  useEffect(() => {
    // Expose handleToggleFavorite for modal button
    window.handleToggleFavoriteFromModal = handleToggleFavorite;
    return () => {
      window.handleToggleFavoriteFromModal = undefined;
    };
  }, [timeSlots]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  const PlusIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="#ffffff" // White fill for the plus sign
    width="24" // Adjust icon size as needed
    height="24"
    style={{ transform: "translateY(-1px)" }}
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" />
  </svg>
);
  return (
    <>

      {isHighmarkPortal ?
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn me-1" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>
          <h2 className="page-heading">{t('appointmentTimeSchedule')}</h2>
        </div> :
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn me-1" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
              {t('Back')}
            </span>
          </button>
          <h2 className="page-heading">{t('appointmentTimeSchedule')}</h2>
        </div>
      }
      <div className="col-md-12 mt-3">
        <h3 className="appointment-selected-date">
              {selectedDate ? new Date(selectedDate).toLocaleDateString('en-GB', {
                  weekday: 'short', 
                  day: '2-digit',   
                  month: 'short',    
                  year: 'numeric',   
                }) : ""}
          </h3>
      </div>
      <div className="col-md-12 mt-5">
        <div className="appointment-time-slots-wrapper">
          
          {/* {timeSlots.length > 0 ? (
        timeSlots.map((slot, index) => (
            <div
              key={index}
              className={`time-slot ${selectedTimeSlot === slot ? "selected" : ""}`}
              onClick={() => handleTimeSlotClick(slot)}
            >
              {slot}
            </div>
        ))
          ) : (
            <p>{t('noTimeSlotsAvailable')}</p>
          ) */}
          {timeSlots.length > 0 ? (
            timeSlots.map((nurse, idx) => (
              <div key={idx} className="appointment-timeslot-item">
                <div className="d-flex align-items-center mb-2">
                  <div onClick={() => { setSelectedNurseProfile(nurse); setShowNurseProfile(true); }}
    style={{
      position: "relative",
      bottom: -30, // Adjust this value to position the icon
      right: -110, // Adjust this value to position the icon
      backgroundColor: isHighmarkPortal ? "#0072CE" : "#EC008C", // Highmark: blue, others: pink
      borderRadius: "50%",
      padding: 5,
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
      cursor: "pointer",
    }}
  >  
    <PlusIcon />
  </div> 

                  <div onClick={() => { setSelectedNurseProfile(nurse); setShowNurseProfile(true); }} style={{ cursor: "pointer" }}>
                    
                    {nurse.NurseimagePath ? (
                      <img
                        src={nurse.NurseimagePath}
                        alt={nurse.NurseFormattedName}
                        style={{ width: 100, height: 100, borderRadius: "100%", marginRight: 10 }}
                      />
                      
                    ) : (
                      <img
                        src={NurseProfilePic}
                        alt={nurse.NurseFormattedName}
                        style={{ width: 100, height: 100, borderRadius: "100%", marginRight: 10 }}
                      
                      />
                      
                    )}
                       
                  </div>
                 
                  <span className="fw-bold text-primary-color">{nurse.NurseFormattedName}</span>
                  {selectedType === "Nurse" && (
                  <span className={`favorites-icon ${nurse.IsPrimaryStatus === "P" ? "favsaved" : ""}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggleFavorite(nurse);
                    }}>
                  </span>)}
                  <div >
                     {selectedType === "Nurse" && (
                    <span className={`favorites-icon ${nurse.IsPrimaryStatus === "P" ? "favsaved" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent the location click handler from firing
                        handleToggleFavorite(nurse, idx);
                      }}>
                    </span> )}</div>
                </div>
                <div className="time-slots-wrapper">
                  {nurse.AvailableSlots.map((slot, sidx) => (
                    <div
                      key={sidx}
                      className={`time-slot ${(selectedNurseIdx === idx && selectedTimeSlot === slot) ? "selected" : ""}`}
                      onClick={() => handleTimeSlotClick(idx, slot)}
                    >
                      {slot}
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <p>{t('noTimeSlotsAvailable')}</p>
          )}
        </div>
        <button className="win-btn-primary mobile-view mt-5 mb-5" onClick={handleBook} disabled={isBooking}>{isBooking ? "Booking..." : t('bookAppointment')}</button>
        <div className="col-12 text-center mb-4">&nbsp;</div>
      </div>
      <div className="col-md-6">
      </div>
      <ErrorModal show={showModal} message={modalMessage} onClose={handleModalClose} closeButton={true} />
      <ErrorModal
        show={showNurseModal}
        onClose={() => setShowNurseModal(false)}
        showConfirmButtons={true}
        message={modalMessage}
        onOkay={confirmCancel}
      />
      <ErrorModal
        show={showFavoriteModal}
        message={
          <>
            Are you sure you want to change your primary Nurse Care Advocate?
            <br />
            This will replace your current primary Nurse Care Advocate with the one you just selected.
          </>}
        onClose={() => {
          if (modalResolver) modalResolver("N"); // User chose No
        }}
        onOkay={() => {
          if (modalResolver) modalResolver("Y"); // User chose Yes
        }}
        showNurseFavorite={true}
      />
      <NurseProfileModal
        show={showNurseProfile}
        onClose={() => setShowNurseProfile(false)}
        nurse={selectedNurseProfile}
        selectedType={selectedType}
      />
    </>
  );
};

export default AppointmentTimeSchedule;
